import { IStepRoute } from "@common/StepperRouter";
import { useStyle } from "./style";
import { useTranslation } from "react-i18next";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IParams {
    buttonType?: "button" | "submit";
    nextStep?: IStepRoute;
    isMobile?: boolean;
    onNextClick?(): void;
}

export const FlyingCartStepperButton = (props: IParams) => {
    const { nextStep, buttonType, onNextClick, isMobile } = props;
    const { classes } = useStyle();

    const { t } = useTranslation("cart");

    if (!nextStep) {
        return null;
    }

    return (
        <LabeledButton
            className={isMobile ? classes.flyingCartMobileButton : classes.flyingCartDesktopButton}
            disableFullWidth
            id={nextStep?.id}
            labelText={t("nextStepLabel", { stepLabel: nextStep?.label })}
            type={buttonType}
            onClick={onNextClick}
        >
            {t("nextStepLabel", { stepLabel: nextStep?.label })}
        </LabeledButton>
    );
};
